import { secondAxios } from "../../../../../../api/axios";

export const get5d = async (equipId) => {
  const response = await secondAxios.get(
    `/cost5d/${equipId}/rev/e09c5521-611c-4865-ab77-7bac1db46937`
  );
  console.log({ response });
  return response.data;
};
